import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { Engagement, IEngagementSingleSchema } from '@ms/telemetry-manager/lib/events/Engagement.event';
import { getTelemetryManager } from './telemetry/getTelemetryManager';

/**
 * Uses logger provided in the configuration, if any, to log engagement data
 * @public
 */
export function logEngagement(payload: IEngagementSingleSchema): IItemCacheThunkAction<void> {
    return (dispatch: IItemCacheDispatch) => {
        const manager = dispatch(getTelemetryManager);

        Engagement.withManager(manager).logData(payload);
    };
}
